import { createListable } from 'listable'
import { combineEpics } from 'redux-observable'
import { createEffects } from './effects'
import { REPORTS_PATH } from 'features/report'
import options from './config'
import * as customActions from './actions'
import { moduleName } from './actions/types'
import customReducer from './reducer'


const listableModule = createListable({
  name: moduleName,
  config: options,
  customActions,
  customReducer,
})

export const config = listableModule.options
export const actions = listableModule.actions

export const effects = combineEpics(
  createEffects(listableModule.actions),
  listableModule.effects,
)

export const reducer = listableModule.reducer
export const types = listableModule.types

export const constants = {
  ...listableModule.constants,
  PATH_ALL: `${REPORTS_PATH}/vehicle-servicing`,
  ROUTE_ALL: `${REPORTS_PATH}/vehicle-servicing`,

  PATH_DRILLDOWN: `${REPORTS_PATH}/vehicle-servicing`,
  ROUTE_DRILLDOWN: `${REPORTS_PATH}/vehicle-servicing/:id/`,

  ROUTE_CONTACT: `${REPORTS_PATH}/vehicle-servicing/:id/contract-details`,
  ROUTE_DRIVER: `${REPORTS_PATH}/vehicle-servicing/:id/driver-details`,
  ROUTE_VEHICLE: `${REPORTS_PATH}/vehicle-servicing/:id/service-history`,
  ROUTE_VARIATIONS: `${REPORTS_PATH}/vehicle-servicing/:id/variations`,
  ROUTE_SERVICE_BOOKINGS: `${REPORTS_PATH}/vehicle-servicing/:id/service-bookings`,
  ROUTE_FBT: `${REPORTS_PATH}/vehicle-servicing/:id/fbt`,
}

